export const ATW_PLATFORM_ORG_ID =
  import.meta.env.VITE_ATW_PLATFORM_ORG_ID?.trim() || "4133643";

export function isAtwPlatformOrg(orgId: string | null | undefined): boolean {
  const o = orgId?.trim();
  if (!o || !/^\d{7}$/.test(o)) return false;
  return o === ATW_PLATFORM_ORG_ID;
}

export function canAccessPlatformApp(
  dashboardOrgId: string | null | undefined,
  role: string | undefined,
): boolean {
  return role === "super_admin" && isAtwPlatformOrg(dashboardOrgId);
}
